import loadable from 'ctrwowShared/utils/loadable';

export default loadable(() => import('./BillingUsageOverviewLayout'));